module.exports = __webpack_public_path__ + "img/4.3.9ead0470.png";